import { Component, OnInit } from '@angular/core';
import { ProductDownloadService } from 'src/app/core/services/product-download.service';
import { CardLink, ProductCard, ProductDirectDownload } from 'src/app/model/product-card';
import { ProductService } from 'src/app/core/services/product.service';
import { AdministrativeInfoContainer } from 'src/app/model/AdministrativeInfo';
import { CustomerService } from 'src/app/core/services/customer.service';
import { ProductCode } from 'src/app/model/industry';
import { ST_Roles, StoreRolesService } from 'src/app/core/services/store-role.service';

@Component({
  selector: 'ms-products-download',
  templateUrl: './products-download.component.html',
  styleUrls: ['./products-download.component.scss']
})
export class ProductsDownloadComponent implements OnInit {
  families: string[] = ["MAGO4", "MAGO.NET", "MAGOCLD", "MAGOWEB"]
  products: ProductCard[] = [];
  isLoading: boolean = false;
  mandatoMagoCloud: string ;
  mandatoMagoWeb: string ;

  constructor(
    private productDownloadService: ProductDownloadService,
    private productService: ProductService,
    public storeRolesService: StoreRolesService
  ) {
  }

  async ngOnInit() {
    this.isLoading = true;
    for(let i = 0; (i < this.families.length); i++){
      try{
        let res = await this.productDownloadService.getProductReleases(this.families[i], this.families[i], 'last', null, null, true)
        if(!res.Result || !res.Content || res.Content.length != 1) throw new Error()
        this.products.push(new ProductCard(this.families[i], this.productService.getProductImage(this.families[i]), res.Content[0].ReleaseNr, this.getDate(res.Content[0].PublicationDate)))
      }
      catch(err){
        this.isLoading = false;
      }
    }
    this.isLoading = false;
  }

  getProductsCard() {
    let gettedProducts: string[] = [];

    if (this.storeRolesService?.isMagoWeb_Partner || this.storeRolesService?.isZucchettiAccount || this.storeRolesService?.IsInternal)
      gettedProducts.push('MAGOWEB');
    if (this.storeRolesService?.isMagoCloud_Partner || this.storeRolesService?.isZucchettiAccount || this.storeRolesService?.IsInternal)
      gettedProducts.push('MAGOCLD');
    if (this.storeRolesService?.isMago4_Partner || this.storeRolesService?.isZucchettiAccount || this.storeRolesService?.IsInternal)
    {
      gettedProducts.push('MAGO4');
      gettedProducts.push('MAGO.NET');
    }

    return this.products.filter((product) => gettedProducts.includes(product.ProductCode));
  }

  getDate(dateString: string): string {
    return new Date(dateString).toLocaleDateString()
  }


}
